<script>
  import {
    updateD,
    searchDoc,
    panelController,
    updateService,
    enviarNotificacion,
  } from "../../../../stores/service";
  import { getStorage, ref, getDownloadURL } from "firebase/storage";
  import { onMount } from "svelte";
  import AdSlot from "../../../../components/ads/AdSlot.svelte";
  import { navigate } from "svelte-routing";
  import { user } from "../../../../stores/user";
  import { createNewDate } from "../../../../Controller/APIs/date";
  import { Collapse } from "bootstrap";
  import MenuView from "../../../../views/admin/rest/menu.svelte";
  import { set_data } from "svelte/internal";
  import { servicioMesa } from "../../../../Controller/cliente/clientService/servicioMesa";
  import { modelValid } from "../../../../Models/modelSystemG";
  import { tableBlocked } from "../../../../Controller/apps/paneListMesas/acceptingTables";

  let servicioMes;
  let mv;
  $: blocked = tableBlocked(
    $panelController.service,
    $panelController.viewMenu.mesa,
  );
  $panelController.viewMenu.doc = { data: {}, id: "", create: false };

  let isCollapsed = true; 

  async function toggleCollapse() {
    $panelController.viewMenu.previewURLMenuStatus = false;
    if ($panelController.service.service.pdfMenu == "") {
      return;
    }

    if (
      $panelController.service.service.pdfMenu.includes(
        "https://drive.google.com/",
      )
    ) {
      $panelController.viewMenu.goolgeDrive = true;
      isCollapsed = false;
      if (!isCollapsed) {
        isCollapsed = true;
      }
      return;
    }

    if (
      $panelController.service.service.pdfMenu.includes(
        "https://firebasestorage.googleapis.com/",
      )
    ) {
      $panelController.viewMenu.goolgeDrive = false;
    }

    if (isCollapsed && !$panelController.viewMenu.goolgeDrive) {
      if ($panelController.service.service.pdfMenu) {
        /* const selectedFile = await response.blob(); */
        $panelController.viewMenu.previewURLMenu =
          $panelController.service.service.pdfMenu;
        isCollapsed = false;
        $panelController.viewMenu.previewURLMenuStatus = true;
      }
    } else {
      isCollapsed = true;
    }
  }

  function selectmesa(index) {
    if (index > 0) {
      $panelController.viewMenu.menuService = true;
      $panelController.viewEvaluacion.pedidos = [];
    }
    0;
  }

  function obtenerURLVistaPrevia(link) {
    if (!link.includes("https://drive.google.com/")) {
      return `${link}#toolbar=0`;
    }

    const urlSplit = link.split("/");
    const fileId = urlSplit[urlSplit.length - 2];
    const previewURL = `https://drive.google.com/file/d/${fileId}/preview`;

    return previewURL;
  }

  async function service(index, opc) {
    let date = await createNewDate("America/Mexico_City");
    if (date.status == false) {
      return false;
    }

    mv = await modelValid({
      doc: "rdDocumentService",
    });
    if (mv.status == false) {
      return;
    }

    servicioMes.upd_service($panelController.service);

    switch (opc) {
      /* pedir */
      case 1:
        if (!date.status) {
          break;
        }

        /* The document was just re-read, so this reflects the owner's latest
           choice: closed means no new tables, active ones carry on. */
        if (tableBlocked($panelController.service, index)) {
          break;
        }

        if ($panelController.viewMenu.mesa == 0) {
          break;
        }

        selectmesa($panelController.viewMenu.mesa);
        console.log("Solicitan servicio",`Mesa ${index}`);
        
        $panelController.service.tableadmins.forEach((element) => {
          if (element.hasOwnProperty("notificaciones")) {
            element.notificaciones.forEach((item) => {
              if (item.active) {
                enviarNotificacion({
                  token: item.token,
                  title: "Solicitan servicio",
                  body: `Mesa ${index}`,
                });
              }
            });
          }
        });
        if (!$panelController.viewMenu.doc.create) {
          $panelController.service = await servicioMes.validDataMes();
          $panelController.service = await servicioMes.setAnalytics();
        }

        await servicioMes.setTimeMes($panelController.viewMenu.mesa);
        $panelController.service = servicioMes.getService();

        $panelController.viewMenu.servicio.status = true;
        $panelController.viewMenu.servicio.time.status = true;
        $panelController.viewMenu.servicio.time.date = date.currentDate;

        await modelValid({
          doc: "updateService",
          data: servicioMes.getService(),
        });
        break;

      case 2:
        /* todo ok */

        $panelController.viewMenu.menuService = true;
        $panelController.viewMenu.servicio.time.status = false;

        await servicioMes.stopTimeMes(index);

        if ($panelController.viewMenu.doc.create) {
          servicioMes.saveData({
            start: $panelController.viewMenu.servicio.time.date,
            end: await date.currentDate,
          });
        }

        if (!$panelController.viewMenu.doc.create) {
          $panelController.viewMenu.doc.create = true;

          await servicioMes.newData({
            user: $panelController.service.listRatinggs[
              $panelController.viewEvaluacion.index[0]
            ].config.login
              ? {
                  status: true,
                  name: $user.displayName,
                  email: $user.email,
                  img: $user.photoURL,
                }
              : {
                  status: false,
                },
            date: date.currentDate,
            mesa: $panelController.viewMenu.mesa,
            listServices: [
              {
                start: $panelController.viewMenu.servicio.time.date,
                end: date.currentDate,
              },
            ],
          });

          $panelController.viewMenu.ind_user = servicioMes.dataView.ind_user;
        }
        $panelController.service = servicioMes.service;

        await modelValid({
          doc: "updateService",
        });
        break;

      case 3:
        /* pedir cuenta */
        $panelController.service.service.mesasService[
          index - 1
        ].service.status = false;
        $panelController.service.service.mesasService[index - 1].cuenta.status =
          true;

        await modelValid({
          doc: "updateService",
        });

        navigate("/evaluacion", { replace: true });
        $panelController.service.tableadmins.forEach((element) => {
          if (element.hasOwnProperty("notificaciones")) {
            if (element.notificaciones[0].active) {
              enviarNotificacion({
                token: element.notificaciones[0].token,
                title: "Solicitan  la cuenta",
                body: `Mesa ${index}`,
              });
            }
          }
        });

        break;

      default:
        break;
    }
  }

  onMount(async () => {
    if ($panelController.viewLogin.url.nmesa !== null) {
      $panelController.viewMenu.mesa = $panelController.viewLogin.url.nmesa;

      selectmesa($panelController.viewLogin.url.nmesa);
    }
    $panelController.viewMenu.listindex =
      $panelController.viewEvaluacion.index[0];
    servicioMes = new servicioMesa(
      $panelController.service,
      $panelController.viewEvaluacion.index[0],
      $panelController.viewMenu,
    );
  });
</script>

<div class="col-12">
  <!-- Widget: user widget style 1 -->
  <div class="card card-widget widget-user shadow">
    <!-- Add the bg color to the header using any of the bg-* classes -->
    <div class="widget-user-header">
      <h3 class="widget-user-username">{$panelController.service.name}</h3>
      <h5 class="widget-user-desc">
        {$panelController.service.listRatinggs[
          $panelController.viewEvaluacion.index[0]
        ].config.name}
      </h5>
    </div>
    <div class="widget-user-image">
      <img
        class="img-circle elevation-2"
        src={$panelController.service.ico}
        alt="..."
      />
    </div>
    <div class="card-footer">
      <h2 class="tx">Bienvenido</h2>

      <div
        class="row d.flex align-items-center justify-content-center text-sm text-md-lg"
      >
        {#if !$panelController.viewMenu.menuService}
          <div class="col-6">
            <select
              class="form-control text-sm"
              bind:value={$panelController.viewMenu.mesa}
            >
              <option selected value={0}> Selecciona una mesa </option>

              {#each $panelController.service.service.mesasService as mMesa, index}
                <option value={index + 1}>
                  Mesa:{index + 1}
                </option>
              {/each}
            </select>
          </div>

          <div class="col-6">
            <button
              type="submit"
              class="btn btn-block btn-lg text-sm text-md-lg"
              on:click={() => {
                selectmesa($panelController.viewMenu.mesa);
              }}>Seleccionar</button
            >
          </div>
        {:else}
          <div id="style-card" class="card col-10">
            <a href="" data-target="#modal-xl" data-toggle="modal">
              <div class="card-header text-center">Mesa:</div>
              <div class="card-body">
                <h3 class="text-center fs-3">
                  {$panelController.viewMenu.mesa}
                </h3>
                {#if $panelController.viewMenu.servicio.time.status}
                  <h3 class="text-center fs-3">Gracias por participar...</h3>
                {:else}
                  <h3 class="text-center fs-3">¿Te podemos apoyar en algo?</h3>
                {/if}
              </div>
            </a>
          </div>
        {/if}
      </div>

      <div class="row d.flex align-items-center justify-content-center">
        {#if $panelController.viewMenu.servicio.status}
          {#if $panelController.viewMenu.servicio.time.status}
            <div class="col-12 col-lg-3 col-sm-4 p-2">
              <button
                type="button"
                class="btn btn-block btn-lg text-sm text-md-lg"
                on:click={() => {
                  service($panelController.viewMenu.mesa, 2);
                }}>LLEGO MI PEDIDO</button
              >
            </div>
          {:else}
            <div class="col-12 col-lg-3 col-sm-4 p-2">
              <button
                type="button"
                class="btn btn-block btn-lg text-sm text-md-lg"
                on:click={() => {
                  service($panelController.viewMenu.mesa, 3);
                }}>PEDIR CUENTA</button
              >
            </div>
            <div class="col-12 col-lg-3 col-sm-4 p-2">
              <button
                type="button"
                class="btn btn-block btn-lg text-sm text-md-lg"
                on:click={() => {
                  service($panelController.viewMenu.mesa, 1);
                }}>PEDIR SERVICIO</button
              >
            </div>
          {/if}
        {:else if blocked}
          <div class="col-12 p-2">
            <p class="closed-note" role="status">
              Por ahora no estamos recibiendo mesas nuevas. Vuelve a intentarlo
              cuando abramos.
            </p>
          </div>
        {:else}
          <div class="col-12 col-lg-3 col-sm-4 p-2">
            <button
              type="button"
              class="btn btn-block btn-lg text-sm text-md-lg"
              on:click={() => {
                service($panelController.viewMenu.mesa, 1);
              }}>PEDIR SERVICIO</button
            >
          </div>
        {/if}

        <div class="col-12 col-lg-3 col-sm-4 p-2">
          <button
            type="button"
            class="btn btn-block btn-lg text-sm text-md-lg"
            data-bs-toggle="collapse"
            data-bs-target="#pdfCollapse"
            aria-expanded={isCollapsed}
            aria-controls="pdfCollapse"
            on:click={toggleCollapse}>MOSTRAR MENU</button
          >
        </div>
      </div>

      <main class="container mt-4">
        <div class="accordion" id="pdfAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header" id="pdfHeading"></h2>
            <div
              id="pdfCollapse"
              class={isCollapsed
                ? "accordion-collapse collapse"
                : "accordion-collapse collapse show"}
              aria-labelledby="pdfHeading"
              data-bs-parent="#pdfAccordion"
            >
              <div class="accordion-body">
                {#if $panelController.viewMenu.goolgeDrive}
                  <iframe
                    src={obtenerURLVistaPrevia(
                      $panelController.service.service.pdfMenu,
                    )}
                    width="100%"
                    height="500px"
                    frameborder="0"
                  ></iframe>
                {:else if $panelController.viewMenu.previewURLMenuStatus}
                  <MenuView pdf={$panelController.service.service.pdfMenu} />
                {/if}
                <!-- -->
              </div>
            </div>
          </div>
        </div>
      </main>

      <!-- /.row -->
    </div>
  </div>
  <!-- /.widget-user -->
</div>

<div class="text-center mt-3">
  <AdSlot />
</div>

<style>
  a {
    color: black;
  }
  .card {
    color: black;
  }
  .tx {
    text-align: center;
  }

  .widget-user-header {
    background-color: rgb(218, 92, 56);
    color: aliceblue;
  }
  .widget-user .widget-user-desc {
    margin-top: 6px !important ;
  }
  .btn {
    background-color: rgb(218, 92, 56);
    border-radius: 25px;
    color: aliceblue;
    font-size: 24px;
  }
  .closed-note {
    margin: 0;
    padding: 0.75rem 1rem;
    border-radius: 16px;
    background: #f8d9c6;
    color: #b14b2c;
    text-align: center;
    font-weight: 600;
  }
  .form-control {
    border-radius: 25px;
    border-color: rgb(218, 92, 56);
    height: 3rem;
    text-align: center;
    font-size: 24px;
  }
</style>
